import axios from 'axios';
import config from '../config/environment';

// Use the local admin backend URL
const LOCAL_ADMIN_API_BASE_URL = config.localAdminBackendUrl;

console.log('🏢 Local Admin API Base URL:', LOCAL_ADMIN_API_BASE_URL);

const localAdminApi = axios.create({
  baseURL: LOCAL_ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Add Bearer token from localStorage to all requests
localAdminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔑 Local Admin Token attached to request:', config.url);
    } else {
      console.warn('⚠️ No token found for local admin request:', config.url);
    }
    
    return config;
  },
  (error) => {
    console.error('❌ Local Admin Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle 401 errors with token refresh
localAdminApi.interceptors.response.use(
  (response) => {
    console.log('✅ Local Admin API Response:', response.config.url, response.status);
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      console.log('🔄 Token expired, attempting refresh...');
      
      const refreshToken = localStorage.getItem('admin_refresh_token');
      if (refreshToken) {
        try {
          const response = await axios.post(
            `${config.getLocalAdminBackendUrl()}/api/admin/auth/refresh`,
            { refresh_token: refreshToken }
          );
          
          const { access_token } = response.data;
          localStorage.setItem('admin_token', access_token);
          
          // Update auth header and retry original request
          originalRequest.headers['Authorization'] = `Bearer ${access_token}`;
          console.log('✅ Token refreshed, retrying request...');
          return localAdminApi(originalRequest);
          
        } catch (refreshError) {
          console.error('❌ Token refresh failed:', refreshError);
          // Fall through to logout
        }
      }
      
      // If refresh failed or no refresh token, logout
      console.error('🚫 Local Admin 401 Unauthorized - Token expired or invalid');
      console.log('🔄 Clearing auth data and redirecting to login...');
      
      // Clear authentication data
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_refresh_token');
      localStorage.removeItem('admin_user');
      
      // Redirect to login page
      window.location.href = '/';
    } else {
      console.error('❌ Local Admin API Error:', error.response?.status, error.message);
    }
    
    return Promise.reject(error);
  }
);

export default localAdminApi;